import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// ng serve uses port 4200. Everywhere else (including a normal ng build)
// the app can be installed. HTML and API stay network-only inside sw.js.
if ('serviceWorker' in navigator && window.location.port !== '4200') {
  var hadWorker = !!navigator.serviceWorker.controller;
  if (hadWorker) {
    navigator.serviceWorker.addEventListener('controllerchange', function () {
      window.location.reload();
    });
  }
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('sw.js').catch(function () {});
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
